import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AddProductToShoppingCartComponent } from 'src/app/modals/add-product-to-shopping-cart/add-product-to-shopping-cart.component';
import { Product } from 'src/app/models/product';
import { FirebaseAuthService } from 'src/app/_services/firebase-auth.service';
import { UserService } from 'src/app/_services/user.service';


@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent implements OnInit {

  @Input() product: Product;
  @Input() diviceXs: boolean;
  @Input() diviceSm: boolean;

  
  infoGessiPoints = false;

  constructor(private matDialog: MatDialog, private userService: UserService, 
              private firebaseAuthService: FirebaseAuthService,  private router: Router) { }
  // constructor(private userService: UserService) { }


  ngOnInit(): void {
  }

  goToProduct(product: Product) : void {
    console.log(product);
    this.router.navigate([`product/${product.id}`]);

  }
  async addToCar(product: Product): Promise<void> {
    product.quantity = 1;

    if (this.firebaseAuthService.publicUser) {
      console.log(this.firebaseAuthService);
      console.log('logueado');
      await this.userService.addProductToShoppingCart(product);
    } else {
      console.log('sin loguearse');
      this.userService.addProductToShoppingCartInLocalStorage(product);
    }

    if (this.diviceXs || this.diviceSm) {
      const dialogRef = this.matDialog.open(AddProductToShoppingCartComponent,
        {
          height: 'auto',
          width: '95%',
          data: {
            product: product,
            quanty: 1
          }
        });
    }
    else {
      const dialogRef = this.matDialog.open(AddProductToShoppingCartComponent,
        {
          height: 'auto',
          width: '60%',
          data: {
            product: product,
            quanty: 1
          }
        });
    }
  }

  goToProductView(productId){
    this.router.navigate([{outlets: {primary: ['product', productId] ,sidebar: ['product', productId]}}]);
  }

  activeInfoGessiPoints() {
    this.infoGessiPoints = true;
  }

  closeInfoGessiPoints() {
    this.infoGessiPoints = false;
  }

}
